import WWWellMaintenance from '../pages/WWWellMaintenance';

const wwwRoute = {
  public: [],
  auth: [
    {
      name: 'maintenance_what_went_well',
      path: '/maintenance/what-went-well',
      permissions: ['admin'],
      component: WWWellMaintenance,
    },
  ],
};

export default wwwRoute;
